import {
  CLEAN_STATE,
  LOAD_SIMILARITY_SEARCH_RESULTS,
  LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE,
  LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS,
  SIMILARITY_SEARCH,
  SIMILARITY_SEARCH_FAILURE,
  SIMILARITY_SEARCH_SUCCESS,
} from './constants';

export const initialState = {
  isSimilarityLoading: false,
  isResultsLoading: false,
  resultPayload: undefined,
  reactions: [],
  totalItems: undefined,
  error: undefined,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAN_STATE:
      return { ...initialState };
    case SIMILARITY_SEARCH:
      return { ...state, isSimilarityLoading: true, resultPayload: undefined, reactions: [], totalItems: undefined, error: undefined };
    case SIMILARITY_SEARCH_SUCCESS: {
      const { resultPayload, totalItems } = action;
      return { ...state, isSimilarityLoading: false, resultPayload, totalItems, reactions: [] };
    }
    case SIMILARITY_SEARCH_FAILURE:
    case LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE:
      return { ...state, isSimilarityLoading: false, isResultsLoading: false, error: action.payload };
    case LOAD_SIMILARITY_SEARCH_RESULTS:
      return { ...state, isResultsLoading: true };
    case LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS: {
      const { searchResult } = action;
      const { reactions } = state;
      return { ...state, isResultsLoading: false, reactions: [...reactions, ...searchResult] };
    }
    default: {
      return state;
    }
  }
}
